import { useState } from 'react';

import { Modal } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import AssociatedIdentities from 'settings/employees/AssociatedIdentities';

export default function WorkspaceEditModalSupport(props: {
	workspace: graphql.Workspace;
	onDismiss: () => void;
}) {
	const [associatedIdentities, setAssociatedIdentities] = useState(
		props.workspace.user?.associatedIdentities.map((identity) => ({
			identityProviderID: identity.identityProvider.id,
			name: identity.name,
		})) ?? [],
	);
	const [ensure] = graphql.useEnsureSupportAssociatedIdentitiesMutation();

	const user = props.workspace.user;

	if (!user) {
		return null;
	}

	return (
		<>
			<Modal.Contents>
				<AssociatedIdentities
					username={user.username}
					email={user.email}
					associatedIdentities={associatedIdentities}
					setAssociatedIdentities={setAssociatedIdentities}
				/>
			</Modal.Contents>
			<Modal.FormFooter
				onCancel={() => props.onDismiss()}
				onSave={async () => {
					await ensure({
						variables: {
							input: {
								names: associatedIdentities.map(({ name }) => name),
								userID: user.id,
								workspaceID: props.workspace.id,
							},
						},
					});
					props.onDismiss();
				}}
				small
			/>
		</>
	);
}
